import React, { useState, useEffect } from "react";
import api from "../services/api"; 
import { useNavigate, Link } from "react-router-dom";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/styles/Login.css"; // استدعينا نفس الستايل الفخم

// --- Icons ---
const EyeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
    <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
  </svg>
);

const EyeSlashIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
    <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
    <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
    <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
  </svg>
);

const ForgotPassword = () => {
  // States
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");

  // Loading & Timer States
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(0);
  
  // UI States for Eyes
  const [showNewPass, setShowNewPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  // Messages & Errors States
  const [globalMessage, setGlobalMessage] = useState({ type: "", text: "" });
  const [fieldErrors, setFieldErrors] = useState({});
  const navigate = useNavigate();

  // Timer Logic
  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  // Helper: Email Validation Regex
  const validateEmailFormat = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  // ==============================
  // STEP 1: Send OTP Handler (المعدلة)
  // ==============================
  const handleSendOTP = async (e) => {
    e.preventDefault();
    setLoading(true);
    setGlobalMessage({ type: "", text: "" });
    setFieldErrors({});

    // 1. Validation
    if (!validateEmailFormat(email)) {
      setFieldErrors({ email: "برجاء إدخال بريد إلكتروني صحيح | Please enter a valid email address." });
      setLoading(false);
      return;
    }

    // 2. API Call
    try {
      const res = await api.post(`/Auth/sendForgotPasswordOTP`, { email });
      setGlobalMessage({ type: "success", text: res.data.message });
      setStep(2);
      setTimer(60);
    } catch (error) {
      const msg = error?.response?.data?.message || "Failed to send OTP";

      if (msg.includes("Wait for the current OTP to expire") || msg.includes("still valid")) {
         setGlobalMessage({ 
            type: "info",
            text: "تم إرسال كود مسبقاً، برجاء مراجعة بريدك | Valid OTP found! Please check your email inbox." 
         });
         setStep(2); 
         setTimer(60); 
      } else {
         setGlobalMessage({ type: "error", text: msg });
      }
    } finally {
      setLoading(false);
    }
  };

  // ==============================
  // Resend OTP Handler
  // ==============================
  const handleResendOTP = async () => {
    if (timer > 0) return;
    setLoading(true);
    setGlobalMessage({ type: "", text: "" });
    
    try {
      await api.post(`/auth/sendForgotPasswordOTP`, { email });
      setGlobalMessage({ type: "success", text: "تم إعادة إرسال الكود بنجاح | OTP resent successfully!" });
      setTimer(60);
    } catch (error) {
      const msg = error?.response?.data?.message || "Failed to resend";
      
      if (msg.includes("Wait for the current OTP")) {
         setGlobalMessage({ type: "info", text: "الكود السابق لا يزال صالحاً | Your previous OTP is still valid. Please check your email." });
         setTimer(60);
      } else {
         setGlobalMessage({ type: "error", text: msg });
      }
    } finally {
      setLoading(false);
    }
  };

  // ==============================
  // STEP 2: Reset Password Handler
  // ==============================
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setGlobalMessage({ type: "", text: "" });
    setFieldErrors({});

    const errors = {};
    let hasError = false;

    // 1. Validation
    if (otp.length < 6) {
        errors.otp = "رمز التحقق يجب أن يكون 6 أرقام | OTP must be 6 characters.";
        hasError = true;
    }

    if (newPass.length < 6 || newPass.length > 30) {
      errors.newPass = "يجب أن تكون بين 6 و 30 حرف | Password must be between 6 and 30 characters.";
      hasError = true;
    }

    if (newPass !== confirmPass) {
      errors.confirmPass = "كلمات المرور غير متطابقة | Passwords do not match.";
      hasError = true;
    }

    if (hasError) {
      setFieldErrors(errors);
      setLoading(false);
      return;
    }

    // 2. API Call
    try {
      await api.post(`/auth/resetPasswordPublic`, {
        email,
        otp,
        newPass,
        confirmPass,
      });

      setGlobalMessage({
        type: "success",
        text: "تم تغيير كلمة المرور! جاري التوجيه.. | Password changed! Redirecting to login...",
      });

      setTimeout(() => {
        navigate('/auth/login')
      }, 2000);
    } catch (error) {
      const msg = error?.response?.data?.message || "Reset failed";
      setGlobalMessage({ type: "error", text: msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="background-wrapper">
        <div className="orb orb-1"></div>
        <div className="orb orb-2"></div>
      </div>

      <div className="login-advanced-container" style={{ paddingTop: "100px", paddingBottom: "50px" }}>
        <Container fluid="md">
          <Row className="justify-content-center m-0">
            <Col xs={12} md={8} lg={6} className="p-0">
              <div className="login-card shadow-lg p-4 p-md-5 d-flex flex-column" style={{ background: "rgba(15, 23, 42, 0.7)", backdropFilter: "blur(20px)" }}>
                
                {/* Header Section */}
                <div className="text-center mb-4">
                  <div className="d-flex flex-column gap-1 mb-2">
                    <h3 className="fw-bold text-white mb-0" dir="rtl">استعادة كلمة المرور</h3>
                    <h4 className="fw-bold mb-0" dir="ltr" style={{ fontSize: "1.2rem", color: "#cbd5e1" }}>Reset Password</h4>
                  </div>
                  <div className="d-flex flex-column gap-1">
                    <p className="small m-0" style={{ color: "#f8fafc" }} dir="rtl">
                      {step === 1 ? "أدخل بريدك الإلكتروني لاستلام رمز التحقق." : "تحقق من بريدك وأدخل الرمز وكلمة المرور الجديدة."}
                    </p>
                    <p className="small m-0" style={{ color: "#94a3b8" }} dir="ltr">
                      {step === 1 ? "Enter your email to receive an OTP." : "Check your email for the OTP and set a new password."}
                    </p>
                  </div>
                </div>

                {/* Global Alerts (Styled for Dark Mode) */}
                {globalMessage.text && (
                  <div
                    className={`alert ${
                      globalMessage.type === "error" 
                        ? "alert-danger bg-danger text-white border-0" 
                        : globalMessage.type === "info" 
                          ? "alert-info bg-info text-white border-0" 
                          : "alert-success bg-success text-white border-0"
                    } text-center bg-opacity-25 backdrop-blur`}
                    role="alert"
                    style={{ borderRadius: "12px", backdropFilter: "blur(10px)" }}
                  >
                    {globalMessage.text}
                  </div>
                )}

                {/* STEP 1: Email Form */}
                {step === 1 && (
                  <form onSubmit={handleSendOTP} noValidate>
                    <div className="input-group-advanced mb-4">
                      <label className="input-label d-flex justify-content-between align-items-center w-100 px-1 mb-1">
                        <span dir="ltr" style={{ color: "#94a3b8", fontSize: "0.85rem", fontWeight: "600" }}>Email Address</span>
                        <span dir="rtl" className="fw-bold" style={{ color: "#f8fafc", fontSize: "0.95rem" }}>البريد الإلكتروني</span>
                      </label>
                      <input
                        type="email"
                        dir="ltr"
                        className={`advanced-input ${fieldErrors.email ? "is-invalid" : ""}`}
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="name@example.com"
                        disabled={loading}
                      />
                      {fieldErrors.email && (
                        <small className="text-danger mt-1 d-block text-center fw-medium">{fieldErrors.email}</small>
                      )}
                    </div>
                    
                    <button
                      type="submit"
                      className="btn-primary-advanced w-100 d-flex flex-column align-items-center justify-content-center gap-1 py-3"
                      disabled={loading}
                    >
                      {loading ? (
                        <div className="d-flex align-items-center gap-2">
                          <Spinner as="span" animation="border" size="sm" />
                          <span className="fw-bold">جاري الإرسال... | Sending...</span>
                        </div>
                      ) : (
                        <>
                          <span style={{ fontWeight: "700", fontSize: "1.1rem" }}>إرسال الرمز</span>
                          <span style={{ fontSize: "0.85rem", opacity: 0.8 }}>Send OTP</span>
                        </>
                      )}
                    </button>
                    
                    <div className="text-center mt-4">
                      <Link to="/auth/login" className="link-advanced link-highlight fw-bold">
                        العودة لتسجيل الدخول | Back to Login
                      </Link>
                    </div>
                  </form>
                )}

                {/* STEP 2: OTP & New Password Form */}
                {step === 2 && (
                  <form onSubmit={handleResetPassword} noValidate>
                    
                    {/* OTP Input */}
                    <div className="input-group-advanced mb-3">
                      <label className="input-label d-flex justify-content-between align-items-center w-100 px-1 mb-1">
                        <span dir="ltr" style={{ color: "#94a3b8", fontSize: "0.85rem", fontWeight: "600" }}>OTP Code</span>
                        <span dir="rtl" className="fw-bold" style={{ color: "#f8fafc", fontSize: "0.95rem" }}>رمز التحقق</span>
                      </label>
                      <input
                        type="text"
                        dir="ltr"
                        className={`advanced-input text-center letter-spacing ${fieldErrors.otp ? "is-invalid" : ""}`}
                        required
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        placeholder="------"
                        maxLength={6}
                        disabled={loading}
                        style={{ letterSpacing: "5px", fontSize: "1.2rem", fontWeight: "bold" }}
                      />
                      {fieldErrors.otp && (
                          <small className="text-danger mt-1 d-block text-center fw-medium">{fieldErrors.otp}</small>
                      )}
                    </div>

                    {/* New Password Input */}
                    <div className="input-group-advanced mb-3">
                      <label className="input-label d-flex justify-content-between align-items-center w-100 px-1 mb-1">
                        <span dir="ltr" style={{ color: "#94a3b8", fontSize: "0.85rem", fontWeight: "600" }}>New Password</span>
                        <span dir="rtl" className="fw-bold" style={{ color: "#f8fafc", fontSize: "0.95rem" }}>كلمة المرور الجديدة</span>
                      </label>
                      <div className="input-wrapper-relative">
                        <input
                          type={showNewPass ? "text" : "password"}
                          dir="ltr"
                          className={`advanced-input with-icon ${fieldErrors.newPass ? "is-invalid" : ""}`}
                          required
                          value={newPass}
                          onChange={(e) => setNewPass(e.target.value)}
                          placeholder="••••••••"
                          disabled={loading}
                        />
                        <button
                          type="button"
                          className="password-toggle"
                          onClick={() => setShowNewPass(!showNewPass)}
                          aria-label="Toggle password visibility"
                        >
                          {showNewPass ? <EyeSlashIcon /> : <EyeIcon />}
                        </button>
                      </div>
                      {fieldErrors.newPass && (
                        <small className="text-danger mt-1 d-block text-center fw-medium">{fieldErrors.newPass}</small>
                      )}
                    </div>

                    {/* Confirm Password Input */}
                    <div className="input-group-advanced mb-4">
                      <label className="input-label d-flex justify-content-between align-items-center w-100 px-1 mb-1">
                        <span dir="ltr" style={{ color: "#94a3b8", fontSize: "0.85rem", fontWeight: "600" }}>Confirm Password</span>
                        <span dir="rtl" className="fw-bold" style={{ color: "#f8fafc", fontSize: "0.95rem" }}>تأكيد كلمة المرور</span>
                      </label>
                      <div className="input-wrapper-relative">
                        <input
                          type={showConfirmPass ? "text" : "password"}
                          dir="ltr"
                          className={`advanced-input with-icon ${fieldErrors.confirmPass ? "is-invalid" : ""}`}
                          required
                          value={confirmPass}
                          onChange={(e) => setConfirmPass(e.target.value)}
                          placeholder="••••••••"
                          disabled={loading}
                        />
                        <button
                          type="button"
                          className="password-toggle"
                          onClick={() => setShowConfirmPass(!showConfirmPass)}
                          aria-label="Toggle password visibility"
                        >
                          {showConfirmPass ? <EyeSlashIcon /> : <EyeIcon />}
                        </button>
                      </div>
                      {fieldErrors.confirmPass && (
                        <small className="text-danger mt-1 d-block text-center fw-medium">{fieldErrors.confirmPass}</small>
                      )}
                    </div>

                    <button
                      type="submit"
                      className="btn-primary-advanced w-100 d-flex flex-column align-items-center justify-content-center gap-1 py-3 mb-3"
                      disabled={loading}
                    >
                      {loading ? (
                        <div className="d-flex align-items-center gap-2">
                          <Spinner as="span" animation="border" size="sm" />
                          <span className="fw-bold">جاري التنفيذ... | Processing...</span>
                        </div>
                      ) : (
                        <>
                          <span style={{ fontWeight: "700", fontSize: "1.1rem" }}>تغيير كلمة المرور</span>
                          <span style={{ fontSize: "0.85rem", opacity: 0.8 }}>Reset Password</span>
                        </>
                      )}
                    </button>

                    {/* Resend Link */}
                    <div className="text-center d-flex flex-column gap-2 mt-3">
                      <div className="d-flex justify-content-center align-items-center gap-2">
                        <span className="small" style={{ color: "#cbd5e1" }}>لم تستلم الرمز؟ | Didn't receive code?</span>
                        <button
                          type="button"
                          className="btn btn-link text-decoration-none p-0 fw-bold m-0"
                          onClick={handleResendOTP}
                          disabled={timer > 0 || loading}
                          style={{
                            fontSize: "0.9rem",
                            color: timer > 0 ? "#6c757d" : "#6366f1",
                          }}
                        >
                          {timer > 0 ? `Resend in ${timer}s` : "Resend OTP"}
                        </button>
                      </div>
                    </div>
                  </form>
                )}

              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default ForgotPassword;

// import React, { useState, useEffect } from "react";
// import api from "../services/api"; // تأكد من المسار
// import { useNavigate } from "react-router-dom";

// const ForgotPassword = () => {
//   // States
//   const [step, setStep] = useState(1);
//   const [email, setEmail] = useState("");
//   const [otp, setOtp] = useState("");
//   const [newPass, setNewPass] = useState("");
//   const [confirmPass, setConfirmPass] = useState("");

//   // Loading & Timer States
//   const [loading, setLoading] = useState(false);
//   const [timer, setTimer] = useState(0);
  
//   // Messages & Errors States
//   const [globalMessage, setGlobalMessage] = useState({ type: "", text: "" });
//   const [fieldErrors, setFieldErrors] = useState({});
//     const navigate = useNavigate();


//   // Timer Logic
//   useEffect(() => {
//     let interval;
//     if (timer > 0) {
//       interval = setInterval(() => {
//         setTimer((prev) => prev - 1);
//       }, 1000);
//     }
//     return () => clearInterval(interval);
//   }, [timer]);

//   // Helper: Email Validation Regex
//   const validateEmailFormat = (email) => {
//     const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return re.test(email);
//   };

//   // ==============================
//   // STEP 1: Send OTP Handler (المعدلة)
//   // ==============================
//   const handleSendOTP = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setGlobalMessage({ type: "", text: "" });
//     setFieldErrors({}); // تصفير الأخطاء القديمة

//     // 1. Validation
//     if (!validateEmailFormat(email)) {
//       setFieldErrors({ email: "Please enter a valid email address." });
//       setLoading(false);
//       return;
//     }

//     // 2. API Call
//     try {
//       const res = await api.post(`/Auth/sendForgotPasswordOTP`, { email });
//       setGlobalMessage({ type: "success", text: res.data.message });
//       setStep(2);
//       setTimer(60);
//     } catch (error) {
//       const msg = error?.response?.data?.message || "Failed to send OTP";

//       if (msg.includes("Wait for the current OTP to expire") || msg.includes("still valid")) {
//          setGlobalMessage({ 
//             type: "info", // لون أزرق بدل الأحمر عشان نطمنه
//             text: "Valid OTP found! Please check your email inbox." 
//          });
//          setStep(2); // Go to Step 2
//          setTimer(60); // نشغل التايمر عشان ميعملش سبام
//       } else {
//          // لو خطأ تاني (الإيميل غلط مثلاً) يفضل مكانه
//          setGlobalMessage({ type: "error", text: msg });
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ==============================
//   // Resend OTP Handler
//   // ==============================
//   const handleResendOTP = async () => {
//     if (timer > 0) return;
//     setLoading(true);
//     setGlobalMessage({ type: "", text: "" });
    
//     try {
//       await api.post(`/auth/sendForgotPasswordOTP`, { email });
//       setGlobalMessage({ type: "success", text: "OTP resent successfully!" });
//       setTimer(60);
//     } catch (error) {
//       const msg = error?.response?.data?.message || "Failed to resend";
      
//       // نفس الفكرة هنا، لو داس resend ولسه الكود صالح، مفيش داعي نطلعه error
//       if (msg.includes("Wait for the current OTP")) {
//          setGlobalMessage({ type: "info", text: "Your previous OTP is still valid. Please check your email." });
//          setTimer(60);
//       } else {
//          setGlobalMessage({ type: "error", text: msg });
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ==============================
//   // STEP 2: Reset Password Handler
//   // ==============================
//   const handleResetPassword = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setGlobalMessage({ type: "", text: "" });
//     setFieldErrors({});

//     const errors = {};
//     let hasError = false;

//     // 1. Validation
//     if (otp.length < 6) {
//         errors.otp = "OTP must be 6 characters.";
//         hasError = true;
//     }

//     if (newPass.length < 6 || newPass.length > 30) {
//       errors.newPass = "Password must be between 6 and 30 characters.";
//       hasError = true;
//     }

//     if (newPass !== confirmPass) {
//       errors.confirmPass = "Passwords do not match.";
//       hasError = true;
//     }

//     if (hasError) {
//       setFieldErrors(errors);
//       setLoading(false);
//       return;
//     }

//     // 2. API Call
//     try {
//       await api.post(`/auth/resetPasswordPublic`, {
//         email,
//         otp,
//         newPass,
//         confirmPass,
//       });

//       setGlobalMessage({
//         type: "success",
//         text: "Password changed! Redirecting to login...",
//       });

//       setTimeout(() => {
//         navigate('/auth/login')

//       }, 2000);
//     } catch (error) {
//       const msg = error?.response?.data?.message || "Reset failed";
//       setGlobalMessage({ type: "error", text: msg });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
//       <div className="card shadow-lg border-0 rounded-4" style={{ maxWidth: "450px", width: "100%" }}>
//         <div className="card-body p-5">
//           {/* Header */}
//           <div className="text-center mb-4">
//             <h3 className="fw-bold text-primary">Reset Password</h3>
//             <p className="text-muted small">
//               {step === 1
//                 ? "Enter your email to receive an OTP."
//                 : "Check your email for the OTP and set a new password."}
//             </p>
//           </div>

//           {/* Global Alerts */}
//           {globalMessage.text && (
//             <div
//               className={`alert ${
//                 globalMessage.type === "error" 
//                   ? "alert-danger" 
//                   : globalMessage.type === "info" 
//                     ? "alert-info" 
//                     : "alert-success"
//               } text-center`}
//               role="alert"
//             >
//               {globalMessage.text}
//             </div>
//           )}

//           {/* STEP 1: Email Form */}
//           {step === 1 && (
//             <form onSubmit={handleSendOTP} noValidate>
//               <div className="mb-3">
//                 <label className="form-label fw-semibold">Email Address</label>
//                 <input
//                   type="email"
//                   className={`form-control form-control-lg ${fieldErrors.email ? "is-invalid" : ""}`}
//                   required
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   placeholder="name@example.com"
//                 />
//                 {fieldErrors.email && (
//                   <div className="invalid-feedback">{fieldErrors.email}</div>
//                 )}
//               </div>
//               <button
//                 type="submit"
//                 className="btn btn-primary w-100 btn-lg shadow-sm"
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <>
//                     <span className="spinner-border spinner-border-sm me-2"></span>
//                     Sending...
//                   </>
//                 ) : (
//                   "Send OTP"
//                 )}
//               </button>
//             </form>
//           )}

//           {/* STEP 2: OTP & New Password Form */}
//           {step === 2 && (
//             <form onSubmit={handleResetPassword} noValidate>
//               {/* OTP Input */}
//               <div className="mb-3">
//                 <label className="form-label fw-semibold">OTP Code</label>
//                 <input
//                   type="text"
//                   className={`form-control form-control-lg text-center letter-spacing ${fieldErrors.otp ? "is-invalid" : ""}`}
//                   required
//                   value={otp}
//                   onChange={(e) => setOtp(e.target.value)}
//                   placeholder="------"
//                   maxLength={6}
//                 />
//                 {fieldErrors.otp && (
//                     <div className="invalid-feedback text-center">{fieldErrors.otp}</div>
//                 )}
//               </div>

//               {/* New Password Input */}
//               <div className="mb-3">
//                 <label className="form-label fw-semibold">New Password</label>
//                 <input
//                   type="password"
//                   className={`form-control form-control-lg ${fieldErrors.newPass ? "is-invalid" : ""}`}
//                   required
//                   value={newPass}
//                   onChange={(e) => setNewPass(e.target.value)}
//                   placeholder="6-30 characters"
//                 />
//                 {fieldErrors.newPass && (
//                   <div className="invalid-feedback">{fieldErrors.newPass}</div>
//                 )}
//               </div>

//               {/* Confirm Password Input */}
//               <div className="mb-4">
//                 <label className="form-label fw-semibold">Confirm Password</label>
//                 <input
//                   type="password"
//                   className={`form-control form-control-lg ${fieldErrors.confirmPass ? "is-invalid" : ""}`}
//                   required
//                   value={confirmPass}
//                   onChange={(e) => setConfirmPass(e.target.value)}
//                   placeholder="Re-enter password"
//                 />
//                 {fieldErrors.confirmPass && (
//                   <div className="invalid-feedback">{fieldErrors.confirmPass}</div>
//                 )}
//               </div>

//               <button
//                 type="submit"
//                 className="btn btn-primary w-100 btn-lg shadow-sm mb-3"
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <>
//                     <span className="spinner-border spinner-border-sm me-2"></span>
//                     Processing...
//                   </>
//                 ) : (
//                   "Reset Password"
//                 )}
//               </button>

//               {/* Resend Link */}
//               <div className="text-center">
//                 <span className="text-muted small">Didn't receive code? </span>
//                 <button
//                   type="button"
//                   className="btn btn-link text-decoration-none p-0 fw-bold"
//                   onClick={handleResendOTP}
//                   disabled={timer > 0 || loading}
//                   style={{
//                     fontSize: "0.9rem",
//                     color: timer > 0 ? "#6c757d" : "#0d6efd",
//                   }}
//                 >
//                   {timer > 0 ? `Resend in ${timer}s` : "Resend OTP"}
//                 </button>
//               </div>
//             </form>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ForgotPassword;